import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-068319d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mb-10" }
const _hoisted_2 = { class: "row mt-n10 px-md-20 g-5" }
const _hoisted_3 = { class: "col col-sm-6 col-md-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card bg-secondary" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Umum"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      onclick: "return false;",
      class: "btn btn-tertiary"
    })
  ])
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "col col-sm-6 col-md-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card bg-secondary" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Peperiksaan"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      onclick: "return false;",
      class: "btn btn-tertiary"
    })
  ])
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "col col-sm-6 col-md-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card bg-secondary" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Perkhidmatan"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      onclick: "return false;",
      class: "btn btn-tertiary"
    })
  ])
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "col col-sm-6 col-md-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card bg-secondary" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Manual Pengguna"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      onclick: "return false;",
      class: "btn btn-tertiary"
    })
  ])
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "container mb-10"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "py-5" }, "Soalan Lazim", -1))
const _hoisted_17 = { class: "row g-5" }
const _hoisted_18 = { class: "col-md-12" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass([
            'card',
            'card-bordered',
            'bg-transparent',
            'border-2',
            'order-secondary',
          ])
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, "Tiada Rekod")
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  class: /*#__PURE__*/_normalizeClass([
              'card',
              'card-bordered',
              'bg-transparent',
              'border-2',
              'border-secondary',
            ])
}
const _hoisted_22 = {
  class: "card-body text-black p-0 m-8 mt-5",
  style: {"height":"10rem","overflow":"hidden"}
}
const _hoisted_23 = { class: "badge badge-outline highlight mb-3" }
const _hoisted_24 = { class: "card-title" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = {
  key: 1,
  class: "container mb-10"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "py-5" }, "Panduan Urusan Peperiksaan", -1))
const _hoisted_28 = { class: "row g-5" }
const _hoisted_29 = { class: "col-md-12" }
const _hoisted_30 = { class: "table table-bordered text-start data-table" }
const _hoisted_31 = {
  class: "fw-bolder fs-6 text-uppercase gs-0",
  role: "row"
}
const _hoisted_32 = {
  key: 0,
  class: "px-2"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "px-2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  style: {"border-left":"1px solid #eee"},
  class: "px-2"
}, "1.", -1))
const _hoisted_36 = {
  key: 2,
  class: "container mb-10"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "py-5" }, "Manual Pengguna", -1))
const _hoisted_38 = { class: "row g-5" }
const _hoisted_39 = { class: "col-md-12" }
const _hoisted_40 = { class: "table table-bordered text-start data-table" }
const _hoisted_41 = {
  class: "fw-bolder fs-6 text-uppercase gs-0",
  role: "row"
}
const _hoisted_42 = {
  key: 0,
  class: "px-2"
}
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "px-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  style: {"border-left":"1px solid #eee"},
  class: "px-2"
}, "1.", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  style: {"border-left":"1px solid #eee"},
  class: "px-2"
}, "2.", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  style: {"border-left":"1px solid #eee"},
  class: "px-2"
}, "3.", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  style: {"border-left":"1px solid #eee"},
  class: "px-2"
}, "4.", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  style: {"border-left":"1px solid #eee"},
  class: "px-2"
}, "5.", -1))
const _hoisted_50 = { class: "container" }
const _hoisted_51 = {
  class: /*#__PURE__*/_normalizeClass([
        'd-flex',
        'flex-center',
        'flex-column',
        'bg-ispk-primary',
        'bg-gradient',
        'p-10',
        'rounded-3',
      ])
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center p-5" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-white" }, "Tidak dapat mencari apa yang anda perlukan?"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, "Try this next steps:")
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-inline-flex align-items-end p-5 bg-light rounded-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "btn btn-sm btn-icon btn-secondary me-5" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-headset text-primary" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Hubungi Kami"),
    /*#__PURE__*/_createElementVNode("small", null, "Team kami sedia membantu anda")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Masthead = _resolveComponent("Masthead")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Masthead, {
      minHeight: 35,
      text: "Apa yang kami boleh bantu?",
      backgroundUrl: "media/svg/misc/background.svg",
      fontSize: 2
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filter = 'UM')),
            class: "cursor-pointer"
          }, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter = 'PP')),
            class: "cursor-pointer"
          }, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter = 'PK')),
            class: "cursor-pointer"
          }, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter = 'Panduan')),
            class: "cursor-pointer"
          }, _hoisted_14)
        ])
      ])
    ]),
    (_ctx.filter != 'Panduan')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("div", _hoisted_18, _hoisted_20, 512), [
              [_vShow, _ctx.soalanLazimList.length < 1]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.soalanLazimList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-md-4"
              }, [
                _createVNode(_component_router_link, {
                  to: {
            name: 'article',
            params: { id: _ctx.strToBase64(JSON.stringify(item)) },
          }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.jenisLabel(item.jenis)), 1)
                        ]),
                        _createElementVNode("h5", _hoisted_24, _toDisplayString(item.tajuk), 1),
                        _createElementVNode("div", {
                          innerHTML: item.kandungan,
                          class: "text-truncate"
                        }, null, 8, _hoisted_25)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.filter == 'PP')
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              (_openBlock(), _createElementBlock("div", {
                key: _ctx.index,
                class: "col-md-12"
              }, [
                _createElementVNode("table", _hoisted_30, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_31, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerConfig, (cell, i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                          (i == 0)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_32, _toDisplayString(cell.name), 1))
                            : (_openBlock(), _createElementBlock("th", _hoisted_33, _toDisplayString(cell.name), 1))
                        ], 64))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_34, [
                    _createElementVNode("tr", null, [
                      _hoisted_35,
                      _createVNode(_component_el_link, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getUserManual(
                  'Manual_Pengguna_Modul_Peperiksaan_iSPK-AG_3.0'
                  )))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Manual Pengguna Modul Peperiksaan ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.filter == 'Panduan')
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              (_openBlock(), _createElementBlock("div", {
                key: _ctx.index,
                class: "col-md-12"
              }, [
                _createElementVNode("table", _hoisted_40, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_41, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerConfig, (cell, i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                          (i == 0)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_42, _toDisplayString(cell.name), 1))
                            : (_openBlock(), _createElementBlock("th", _hoisted_43, _toDisplayString(cell.name), 1))
                        ], 64))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_44, [
                    _createElementVNode("tr", null, [
                      _hoisted_45,
                      _createVNode(_component_el_link, {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getUserManual(
                  'Manual_Pengguna_Awam_Skim Perakaunan_Skim Gunasama_25082025_v1.2'
                  )))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Manual Pengguna Awam (Pegawai Skim Perakaunan Dan Gunasama(JANM)) ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_46,
                      _createVNode(_component_el_link, {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getUserManual(
                  'Manual_Pengguna_PSM_v1'
                  )))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Manual Pengguna PSM (Pendaftaran & Pengenalan Dashboard PSM) ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_47,
                      _createVNode(_component_el_link, {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getVid('Manual Pengguna Awam_Lupa Kata Laluan')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Video Manual Pengguna Awam - Lupa Kata Laluan ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_48,
                      _createVNode(_component_el_link, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (
                    _ctx.getVid(
                      'Manual Pengguna Awam_Modul Pengurusan Pengguna 31012023'
                    )
                  ))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Video Manual Pengguna Awam - Modul Pengurusan Pengguna ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_49,
                      _createVNode(_component_el_link, {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (
                    _ctx.getVid(
                      'Manual Pengguna PSM 31012025'
                    )
                  ))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Video Manual Pengguna PSM - Pendaftaran & Pengenalan Dashboard PSM ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_50, [
      _createElementVNode("div", _hoisted_51, [
        _hoisted_52,
        _createVNode(_component_router_link, {
          to: { name: 'contact-us' },
          class: "text-black"
        }, {
          default: _withCtx(() => [
            _hoisted_53
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}